<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :module_name="page.name"/>
    <v-row>
      <v-col>
        <v-card class="pa-5" :loading="loading" :disabled="loading">
          <v-data-table
              :headers="headers"
              :items="records"
              :loading="loading"
              class="elevation-1"
              item-key="id"
              selectable-key="id"
              :show-select="false"
              :options.sync="options"
              :footer-props="footer_props"
              :custom-sort="customSort"
              :search="search">
            <template v-slot:top>
              <v-text-field
                  v-model="search"
                  @click:clear="clearSearch"
                  :label="$store.getters.translate('search')"
                  clearable
                  outlined
                  dense
                  append-icon="mdi-magnify"/>
            </template>
            <template v-slot:body="props">
              <tbody>
                <tr v-for="(item, index) in props.items" :key="index">
                  <td><a @click="editScheme(item)">{{ item.id }}</a></td>
                  <td><a @click="editScheme(item)">{{ item.name }}</a></td>
                  <td v-for="index in [0,1,2,3]" :key="index">
                    <v-text-field v-if="item.scheme_sessions[index]" :label="item.scheme_sessions[index].name" v-model="item.scheme_sessions[index].price"/>
                  </td>
                  <td><v-text-field :label="$store.getters.translate('course_price')" v-model="item.course_price"/></td>
                  <!--ACTION BUTTONS-->
                  <td style="text-align: right">
                    <v-icon class="mr-2" @click="save(item)">mdi-content-save</v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseBreadcrumb from "../../components/commonComponents/BaseBreadcrumb";
import helpFunctions from "../../plugins/helpFunctions";

export default {
  components: {
    BaseBreadcrumb,
  },
  data() {
    return {
      page: {
        title: this.$store.getters.translate("scheme_prices"),
        name: "schemeprices",
        model: "schemeprice",
      },
      loading: false,
      headers: [],
      records: [],
      search: "",
      options: {},
      footer_props: {
        itemsPerPageOptions: [15, 25, 50, 75, 100, 125, 150, 175, 200],
        rowsPerPageText: "Rows per page:",
      },
    };
  },
  created() {
    if(helpFunctions.getLocalStorageValue(this.page.name + "_options")) {
      this.options = helpFunctions.getLocalStorageValue(this.page.name + "_options");
    }
    this.headers = helpFunctions.schemeprices_headers;
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.$http
          .get(this.$store.getters.appUrl + "v2/get-scheme-prices")
          .then((response) => {
            this.records = response.data;
            this.loading = false;
          })
          .catch((error) => {
            if (this.$store.getters.isLoggedIn) {
              this.$toasted.error(error);
            }
            this.loading = false;
          });
    },
    save(item) {
      this.loading = true;
      this.$http
          .post(this.$store.getters.appUrl + "v2/update-scheme-prices", item)
          .then(() => {
            this.loading = false;
            this.$toasted.success(this.$store.getters.translate("success"));
          })
          .catch((error) => {
            this.loading = false;
            this.$toasted.error(error);
          });
    },
    clearSearch() {
      this.search = "";
    },
    customSort(items, index, isDesc) {
      let field = index[0];
      let desc = isDesc[0];
      let result = this.$lodash.sortBy(items, field);
      if (desc) {
        return result.reverse();
      }
      return result;
    },
    editScheme(item) {
      this.$router.push("/schemes/" + item.id);
    },
  },
  watch: {
    options: {
      handler() {
        helpFunctions.setLocalStorageValue(this.page.name + "_options", this.options);
      },
      deep: true,
    },
  },
};
</script>
